var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('h2',[_vm._v("404")]),_c('p',[_vm._v("页面不存在,或者你还没被授予访问它的权限。")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.goHome}},[_vm._v("返回首页")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }